import AxiosInstance from "./api";

export const PayrollDeductionsRemittanceStatementService = {
  getPaginate: async (query) => {
    return await AxiosInstance.get("/private/payroll-deductions-remittance-statement", {
      params: query,
    });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/payroll-deductions-remittance-statement/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/payroll-deductions-remittance-statement", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/payroll-deductions-remittance-statement/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/payroll-deductions-remittance-statement/${id}`);
  },
};
